const DebtPayoffLoanTypeList = [
    { text: 'Credit Card', value: 'Credit Card' },
    { text: 'Medical Expenses', value: 'Medical Expenses' },
    { text: 'Personal Loan', value: 'Personal Loan' },
    { text: 'Collections', value: 'Collections' },
    { text: 'Business Debts', value: 'Business Debts' },
    { text: 'Student Loans', value: 'Student Loans' },
    { text: 'Other', value: 'Other' },
];

const MortgageLoanTypeList = [
    { text: 'Home Purchase', value: 1 },
    { text: 'Home Refinance', value: 2 },
];

const MortgagePropertyTypeList = [
    { text: 'Single family home', value: 'SINGLEFAMDET' },
    { text: 'Townhome', value: 'SINGLEFAMATT' },
    { text: 'Condo', value: 'LOWRISECONDO' },
    { text: 'Multi family dwelling', value: '2TO4UNITFAM' },
    { text: 'Mobile/Manufactured home', value: 'MOBILEPERMANENT' },
];

const PropertyIntentionList = [
    { text: 'Primary residence', value: 'OWNEROCCUPIED' },
    { text: 'Secondary home', value: 'SECONDHOME' },
    { text: 'Investment property', value: 'INVESTMENTPROPERTY' },
];

const ProductTypeList = [
    { text: 'Home Purchase', value: 'purchase' },
    { text: 'Home Refinance', value: 'refinance' },
];

const PersonalLoanPurposeList = [
    { text: 'Debt Consolidation', value: 'Debt Consolidation' },
    { text: 'Credit Card Refinance', value: 'Credit Card Refinance' },
    { text: 'Home Improvement', value: 'Home Improvement' },
    { text: 'Car Financing', value: 'Car Financing' },
    { text: 'Business Loan', value: 'Business' },
    { text: 'Other', value: 'Other' },
];

const MortgageCTAList = [
    { text: 'Purchase', value: 'purchase' },
    { text: 'Refinance', value: 'refinance' },
    { text: 'Home Equity', value: 'home-equity' },
];

const MortgageRateList = [
    { text: 'Purchase', value: 'Purchase' },
    { text: 'Refinance', value: 'Refinance' },
];

const MortgagePropertyUseList = [
    { text: 'Primary Home', value: 'Primary Home' },
    { text: 'Secondary Home', value: 'Secondary Home' },
    { text: 'Investment Property', value: 'Investment Property' },
];

const AutoLoansCTAList = [
    { text: 'New', value: 'new' },
    { text: 'Used', value: 'used' },
    { text: 'Refinance', value: 'refinance' },
];

export default {
    DebtPayoffLoanTypeList,
    MortgageLoanTypeList,
    MortgagePropertyTypeList,
    PropertyIntentionList,
    ProductTypeList,
    PersonalLoanPurposeList,
    MortgageCTAList,
    MortgageRateList,
    MortgagePropertyUseList,
    AutoLoansCTAList,
};
